import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { MerchCardColumns } from 'pricing-pages-ui-components/components/MerchCardColumns';
import { FreeToolsMerchCard } from '../../containers/merch-card/cards/FreeToolsMerchCard';
import { HubMerchCard } from '../../containers/merch-card/cards/HubMerchCard';
import { CustomerPlatformFeaturesContainer } from '../../containers/merch-card/features-display/customer-platform/CustomerPlatformFeaturesContainer';
import { MerchCardTitleContainer } from '../../containers/merch-card/headings-display/MerchCardTitleContainer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FreeToolsMerchCards = () => {
  return /*#__PURE__*/_jsx(View, {
    position: "relative",
    marginBlockEnd: "800",
    children: /*#__PURE__*/_jsxs(MerchCardColumns, {
      columns: 2,
      children: [/*#__PURE__*/_jsx(FreeToolsMerchCard, {
        columnStart: 1,
        Title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.customerPlatform.freeCard.title"
        }),
        HubDescription: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.customerPlatform.freeCard.description"
        }),
        Features: /*#__PURE__*/_jsx(CustomerPlatformFeaturesContainer, {
          productLevel: "FREE",
          productApiName: "hubspot-free"
        }),
        trackingSource: "free-card"
      }), /*#__PURE__*/_jsx(HubMerchCard, {
        apiName: "crm-suite-starter-bundle",
        columnStart: 2,
        Title: /*#__PURE__*/_jsx(MerchCardTitleContainer, {
          Title: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "pricing-pages-ui.merchCardsV2.customerPlatform.starterCard.title"
          })
        }),
        Subheading: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.merchCardsV2.customerPlatform.starterCard.description"
        }),
        Features: /*#__PURE__*/_jsx(CustomerPlatformFeaturesContainer, {
          productLevel: "STARTER",
          productApiName: "crm-suite-starter-bundle"
        })
      })]
    })
  });
};